import { render, staticRenderFns } from "./GarbageStationViewer.vue?vue&type=template&id=279d8a8e&scoped=true"
import script from "./GarbageStationViewer.vue?vue&type=script&lang=js"
export * from "./GarbageStationViewer.vue?vue&type=script&lang=js"
import style0 from "./GarbageStationViewer.vue?vue&type=style&index=0&id=279d8a8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279d8a8e",
  null
  
)

export default component.exports